import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import { map, isEmpty } from "lodash";

export default class ListGraphicV2 extends AcquireWebComponent {
  render() {
    const {
      title,
      data,
      footer,
      subTitle,
    } = this.props;

    if (isEmpty(data)) {
      return (
        <div>
          <div style={{ fontSize: "24px", fontWeight: "bold", textTransform: 'capitalize' }}>{title}</div>
          <div
            style={{
              minHeight: "200px",
              textAlign: "center",
              paddingTop: "60px",
              color: "#CDCDCD",
            }}
          >
            <div style={{ color: "#CDCDCD", fontSize: "24px", opacity: "0.8" }}>
              No Data
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="list-title" style={{
          fontSize: '24px',
          fontWeight: 'bold',
          textTransform: 'capitalize'
        }}>{title}</div>
        <div
          className="text-right mt-10 mb-10"
          style={{
            fontSize: "16px",
            background: "#F5F5F5",
            padding: "15px 20px",
          }}
        >
          <strong>{subTitle}</strong>
        </div>
        <div className="content">
          {map(data, this.renderItem())}
        </div>
        { footer && <div>{footer}</div> }
      </div>
      );
  }

  renderItem = () => {
    const wrapValue = val => {
      if (val === "N/A") {
        return "Unknown";
      }
      if (val === "0.00%") {
        return "Unknown";
      }
      return val;
    };
   return (obj, idx) => {
    return (
        <div
          key={"list-" + idx}
          className="light-grey-top-border pb-15 pt-15 pr-20"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div>
            <span>{obj.name}</span>
          </div>
          <div>
            <div className="pl-20">
              {wrapValue(obj.value)}
            </div>
          </div>
        </div>);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Insights/website/ListGraphic.jsx